import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 2,
    type: CHECKLIST_ITEM_TYPE.EMAIL_SENT,
    manifestKey: 'EMAIL_SENT',

    try_it: {
        button_label: 'Open Email Composer',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ComposerCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { message_id: 'demo-email-001', email: 'demo@dental-sem.co.uk' },
            composerType: 'EMAIL',
        },
    },
    pre_flight_diff: [
        'Step 1: Email dispatched via CRM (separate pre-complete action)',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'Email row added to lead\'s outgoing email tab',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        '⚠ Drift risk: if step 2 fails after step 1, email sent but item stays PENDING — duplicate on retry',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
